module.exports = __webpack_public_path__ + "media/savings_calculator/finaid_calculators-38b3a4ab.png";